export const EWebhookType = {
  CREATE: "create",
  DELETE: "delete",
  UPDATE: "update",
} as const;

export type EWebhookType = (typeof EWebhookType)[keyof typeof EWebhookType];
